<template>
  <div id="app">
    <navbar />
    <router-view/>
    <footerbar />
    <notifications group="notifications" position="bottom left" />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footerbar from '@/components/Footer.vue'

export default {
  components: {
    Navbar,
    Footerbar
  }
}
</script>

<style lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  color: black;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.5em !important;
  font-size: 20px !important;
  text-align: justify !important;
}

img {
  max-width: 100%;

  @include media-breakpoint-down(md) {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

h1 {
  text-transform: uppercase;
  font-weight: bold !important;
}

#nosotros {
  height: calc(100vh - 100px);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @include media-breakpoint-up(sm) {
    height: 406px;
  }

  @include media-breakpoint-up(lg) {
    height: 524px;
  }

  .container {
    height: 100%;

    .row {
      height: 100%;

      .col {
        background-color: rgba(255, 255, 255, 0.5);
        padding-top: 30px;
        padding-bottom: 30px;

        @include media-breakpoint-up(sm) {
          margin-bottom: 15px;
          padding: 15px;
        }
      }
    }
  }
}

.section {
  padding: 40px 0;
  scroll-margin: 100px;

  &:nth-child(odd) {
    background-color: #f1f1f1;
  }
}

#home {
  margin-top: 100px;
}

.nav-item {
  @include media-breakpoint-down(md) {
    padding: 5px 0 !important;
    border-bottom: 1px solid #734040;
  }

  text-align: center;
}

.agile {
  &__nav-button {
    background: transparent;
    border: none;
    color: #ccc;
    cursor: pointer;
    font-size: 24px;
    transition-duration: .3s;

    &:hover {
      color: #888
    }
  }

  .agile__dots {
    margin: auto;
  }

  &__dot {
    margin: 0 10px;

    &.agile__dot--current,
    &:hover {
      button {
        background-color: #888;
      }
    }

    button {
      background-color: #c79b9b;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      display: block;
      height: 10px;
      font-size: 0;
      line-height: 0;
      margin: 0;
      padding: 0;
      transition-duration: .3s;
      width: 10px;
    }
  }

  .agile__slide {
    padding: 5px !important;

    img {
      border: 1px solid #eaeaea;
    }

    p {
      font-size: 0.6em;
      font-weight: bold;
    }
  }
}
</style>
